<template>
    <div class="relative flex flex-col w-full bg-white pt-3 pb-5 font-sans">
        <button class="absolute pin-t pin-r outline-none m-3 md:m-6 pt-3 z-40" @click="delete_modal = true" v-if="showDeleteModalCross">
            <img class="h-4 w-4" src="@/assets/SVG/cross-partners.svg" alt="cross-partners"/>
        </button>
        <component ref="step"
                   @changedGamesStore="updateStore"
                   @updateOrderStepCount="updateOrderStepCount"
                   @updateAllowedTeams="updateAllowedTeams"
                   @ignoresAllowedTeams="ignoresAllowedTeams($event)"
                   v-bind="gamesStore"
                   :is="currentStepPage"
                   :key="currentStep"
                   v-if="loaded && Object.keys(gameTypes).length !== 0"
                   :gameTypes="gameTypes"
                   :gameTypeChain="gameTypeChain"
                   :game-type-min-dates="gameTypeMinDates"
                   :event-uuid="$route.params.draft_uuid"
                   @toggleShowDeleteModalCross="showDeleteModalCross = !showDeleteModalCross"
                   :show-header="false"
                   :is-edited="isEdited"
                   :is-registration-opened="isRegistrationOpened"
                   class="pt-6 pl-4 md:pl-10 pb-6 pr-3 md:pr-6 border border-additional-text"
        ></component>
        <div class="flex flex-row justify-between ml-2 pt-6" v-if="loaded">
            <button v-if="currentStep !== 1" @click="backStep"
                    class="outline-none rounded-full flex flex-row bg-white">
                <font-awesome-icon class="fill-current text-center text-main-text text-l"
                                   style="transform: rotate(180deg)"
                                   :icon="['fas', 'long-arrow-right']"></font-awesome-icon>
                <span class="md:mx-3 font-semibold text-sm md:text-base text-main-text">Назад</span>
            </button>
            <div class="flex flex-row ml-auto">
                <button v-if="currentStep === totalSteps" :disabled="isBtnDisabled"
                        :class="[ isBtnDisabled ? 'bg-disabled text-white cursor-default' : 'bg-brand-yellow text-main-text']"
                        @click="save(true)" class="inline-block justify-center hover-up font-bold rounded-full px-6 py-3 outline-none">
                    Сохранить изменения
                </button>
                <button @click="save(false)" v-if="currentStep !== totalSteps" :disabled="spinner"
                        class="relative outline-none ml-4 rounded-full hover-up flex flex-row items-center justify-center bg-brand-yellow px-8 min-w-68 min-h-10">
                  <img v-if="spinner" class="spinner absolute h-6" src="@/assets/SVG/tail-spin-results.svg" alt="spinner">
                  <span v-else class="flex items-center">
                  <span class="mx-3 font-semibold text-sm md:text-base text-main-text">Продолжить</span>
                    <font-awesome-icon class="fill-current text-center text-main-text text-l"
                                       :icon="['fas', 'long-arrow-right']"></font-awesome-icon>
                  </span>
                </button>
            </div>
        </div>
        <delete-modal key="delete_modal" v-if="delete_modal" @close="delete_modal = false"
                      @white_button="save(false)" @yellow_button="$router.push('/partners')"
                      :text="'При закрытии несохраненные данные будут потеряны'"
                      :button_text_firs="button_text_first" :button_text_second="'Закрыть'"
                      class="z-50 flex"></delete-modal>
    </div>
</template>

<script>
import Form from 'form-backend-validation';
import client from '@/clients/partners';
import DeleteModal from '../order/delete-modal.vue';

export default {
  name: 'edit-record',
  components: { DeleteModal },
  data() {
    return {
      gameTypeChain: null,
      totalSteps: 4,
      loaded: false,
      gameTypes: {},
      gameTypeMinDates: [],
      isRegistrationOpened: false,
      gamesStore: new Form({
        advertisement: [],
        advertisementOrder: [],
        allowed_teams: [],
        ignores_allowed_teams_rule: false,
        dates: [],
        game_type_id: null,
        game_topic_id: null,
        registration_at: new Date(),
        price: 300,
        is_free: false,
        status: '',
        stream: '',
      }, { http: client, resetOnSuccess: false }),
      currentStep: 1,
      delete_modal: null,
      isEdited: true,
      showDeleteModalCross: true,
      spinner: false,
    };
  },
  created() {
    this.getGamesStore();
    client.get(`/game-types?event_order=${this.$route.params.draft_uuid}`)
      .then((data) => {
        this.gameTypes = data.data.data;
      });
  },
  computed: {
    currentStepPage() {
      const step = this.currentStep;
      return () => import(/* webpackChunkName: "partners-order-game" */ `../order/steps/step${step}.vue`);
    },
    button_text_first() {
      return '';
    },
    isBtnDisabled() {
      return this.totalSteps === 5 && !this.gamesStore.allowed_teams.length && !this.gamesStore.ignores_allowed_teams_rule;
    },
  },
  methods: {
    nextStep() {
      if (this.currentStep >= this.totalSteps) {
        return;
      }
      this.currentStep += 1;
      this.spinner = false;
    },
    backStep() {
      this.currentStep -= 1;
    },
    getGamesStore() {
      client.get(`/records/${this.$route.params.uuid}`)
        .then(({ data: { data: event } }) => {
          this.gameTypeChain = event.game_type_chain;
          this.gamesStore.populate(event);
          this.gameTypeMinDates = event.game_type_min_dates;
          this.isRegistrationOpened = event.is_registration_opened;
          this.loaded = true;
        });
    },
    save(final = false) {
      this.spinner = true;
      this.$refs.step.validate()
        .then(() => {
          this.gamesStore.put(`/records/${this.$route.params.uuid}`).then(() => {
            this.loaded = false;
            this.getGamesStore();
            this.delete_modal = false;
            if (final) {
              this.$router.push('/partners');
            }
            if (this.currentStep !== this.totalSteps) {
              this.nextStep();
            }
          });
        });
    },
    close() {
      this.$emit('closed');
    },
    updateStore(updatedGames) {
      console.log(this.gamesStore);
      console.log(updatedGames);
      this.gamesStore.populate(updatedGames);
      console.log(this.gamesStore);
    },
    updateOrderStepCount(newOrder) {
      this.totalSteps = newOrder;
    },
    updateAllowedTeams(teams) {
      this.gamesStore.allowed_teams = teams;
    },
    ignoresAllowedTeams(event) {
      this.gamesStore.ignores_allowed_teams_rule = event;
    },
  },
};
</script>

<style scoped>
    .date-picker /deep/ input {
        display: block !important;
        border-bottom: 2px solid rgb(218, 225, 231);
        margin-left: 1rem;
        outline: none;
        width: 50px !important;
    }
    .close-steps {
        margin-top: 7px;
        margin-right: 215px;
        right: 0;
        position: absolute;
        float: right;
    }

    .spinner {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

</style>

